import React from "react";
import { useI18n } from "@/i18n";

export default function CookiePolicy() {
  const { t } = useI18n();
  const sections = [1, 2, 3, 4, 5, 6];
  return (
    <div className="bg-white" data-testid="page-cookies">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <p className="text-xs uppercase tracking-widest text-[#006837] font-semibold">Paynoravello · MX</p>
        <h1 className="mt-2 font-serif-heading text-4xl sm:text-5xl font-black text-slate-900 leading-tight">
          {t("cookies.title")}
        </h1>
        <p className="mt-2 text-sm text-slate-500">{t("cookies.updated")}</p>
        <p className="mt-6 text-base text-slate-700 leading-relaxed">{t("cookies.intro")}</p>
        <div className="mt-10 space-y-8">
          {sections.map((n) => (
            <section key={n} data-testid={`cookies-section-${n}`}>
              <h2 className="font-serif-heading text-xl sm:text-2xl font-bold text-slate-900">
                {t(`cookies.s${n}Title`)}
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">{t(`cookies.s${n}Body`)}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
